import React, { useState } from "react";
import {
  TextField,
  StandardTextFieldProps,
  Typography,
  Stack,
} from "@mui/material";
import InfoMsg from "./InfoMsg";

interface Props extends StandardTextFieldProps {
  changeHandler: (val: string) => void;
  info?: string;
  projectnameexists?: string;
  webLink?: string;
}

const TextBox = ({
  changeHandler,
  info,
  required,
  label,
  webLink,
  ...props
}: Props) => {
  const [remainingLen, setRemainingLen] = useState(
    props.inputProps?.maxLength || 0
  );
  const [touched, setTouched] = useState(false);

  const handleChange = (
    e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement> | undefined
  ) => {
    if (e) {
      if (props.inputProps?.maxLength) {
        setRemainingLen(props.inputProps?.maxLength - e.target.value.length);
      }
      changeHandler(e.target.value);
    }
  };
  const handleBlur = () => {
    setTouched(true);
  };

  return (
    <>
      <Stack direction="row">
        <Typography
          component="span"
          variant="subtitle2"
          className={`${required ? "field-required" : ""}`}
        >
          {label}
        </Typography>
        {info && <InfoMsg info={info} />}
        {webLink ? (
          <a
            href="https://www.transparency.org/en/cpi/2022"
            target="_blank"
            rel="noopener noreferrer"
          >
            (https://www.transparency.org/en/cpi/2022)
          </a>
        ) : (
          ""
        )}
      </Stack>

      <TextField
        {...props}
        onChange={handleChange}
        onBlur={handleBlur}
        error={
          (touched && required && !props.value) ||
          props.projectnameexists === "true"
        }
        helperText={
          touched && required && !props.value
            ? "This field is required"
            : props.projectnameexists === "true"
            ? props.helperText
            : props.inputProps?.maxLength
            ? `Remaining characters ${remainingLen}`
            : null
        }
      />
    </>
  );
};

export default TextBox;
